import React, { createContext, useContext, useState } from "react";

const CartContext = createContext({});

export function CartProvider({ children }) {
    const [itens, setItens] = useState([]);
    const [observations, setObservations] = useState('');
    const [name, setName] = useState('');
    const [totalValue, setTotalValue] = useState(0);

    function insertManyItems(items) {
        setItens(items);

        setTotalValue(items.reduce((sum, item) => sum + (Number(item.preco) * Number(item.amount || 1)), 0));
    }
    
    function removeItem(id) {
        const newItens = [...itens];

        const itemIndex = newItens.findIndex(item => item.id === id);
        
        setTotalValue(totalValue - (Number(itens[itemIndex].preco) * Number(itens[itemIndex].amount || 1)));

        newItens.splice(itemIndex, 1);
        
        setItens(newItens);
    }

    function clearCart() {
        setItens([]);
        setObservations('');
        setTotalValue(0);
    }

    return (
        <CartContext.Provider value={{ 
            itens, insertManyItems, removeItem, totalValue, name, setName, observations, setObservations, clearCart
        }} >
            {children}
        </CartContext.Provider>
    );
}

export function useCart() {
    return useContext(CartContext);
}
